import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagamentosService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  // Pra não precisar adicionar o token em toda requisição
  // olhar os interceptores do angular (https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8)
  
  getStoredLeftTime (timeLeft: string, destroyedAt: string) {
    if(!timeLeft || !destroyedAt) return

    const [minutes, seconds] = timeLeft.split(":").map(Number);
    const initialTimeLeftInSeconds = minutes * 60 + seconds;
    
    const destroyedAtDate: any = new Date(destroyedAt);
    
    const currentDate: any = new Date();
    
    const differenceInSeconds = (destroyedAtDate - currentDate) / 1000;
    const updatedTimeLeftInSeconds = initialTimeLeftInSeconds + differenceInSeconds;
    
    return updatedTimeLeftInSeconds
  }

  storePayment (chargeId: string, data: any) {
    return this.http.post(`${this.serverUrlService.getUrl()}/charges/save-scheduling`, {
      charge_id: chargeId, scheduling: data
    });
  }

  generatePixCharge (baseUrl: string, body: any) {
    return this.http.post(`${baseUrl}/api/v3/payments`, body)
  }

  // TLDR: Sempre que o angular fizer uma chamada http
  // passa pelo interceptor e adiciona o token
  gerarCobranca(params, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    const body = params;

    return this.http.post(`${this.serverUrlService.getUrl()}/gerar-cobranca`, body, httpOptions);
  }

  getCharge(chargeId: string) {
    return this.http.get(`${this.serverUrlService.getUrl()}/charges/${chargeId}`);
  }

  deleteCharge(chargeId: string, preventUnlock?: boolean) {
    if (!preventUnlock) {
      this.unlockScheduleTime().subscribe(() => {})
    }
    return this.http.delete(`${this.serverUrlService.getUrl()}/charges/${chargeId}`);
  }

  unlockScheduleTime() {
    const schedulingInfo = sessionStorage.getItem('horarioSel')
    if(!schedulingInfo) return of(null)
    
    const jsonSchedulingInfo = JSON.parse(schedulingInfo)
    const data = {horarios: [
      {
        "hora": jsonSchedulingInfo.hora.hora,
        "data": jsonSchedulingInfo.hora.dataconsulta.split(' ')[0],
        "agenda_tipo": jsonSchedulingInfo.hora.tipo,
        "agenda_id": jsonSchedulingInfo.hora.agendaid
      }
    ]}
    return this.http.post(`${this.serverUrlService.otimusUrl}/api/v1/horarios/destranca`, data)
  }

  getPix (chargeId: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        token
      }),
      observe: 'response' as 'body'
    }

    return this.http.get(`${this.serverUrlService.getUrl()}/pix/generate-qrcode/${chargeId}`, httpOptions)
  }

  getTransactionById (chargeId: any) {
    return this.http.get(`${this.serverUrlService.getUrl()}/pix/transactions/${chargeId}`)
  }

  migrarParametros() {
    return this.http.post(`${this.serverUrlService.getUrl()}/asaas/migrar-parametros`, {})
  }

  getPixWebhook () {
    return this.http.get(`${this.serverUrlService.getUrl()}/pix/webhook`)
  }
}
